"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesConsentProvider = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const router_1 = require("@reach/router");
const ServicesContextProvider_1 = require("./ServicesContextProvider");
const CookiesConsentContextProvider_1 = require("./CookiesConsentContextProvider");
const GoogleTagManager_1 = __importDefault(require("../components/GoogleTagManager"));
const cookiesConsentProviderConfig_1 = require("./cookiesConsentProviderConfig");
const CookiesConsentProvider = (props) => {
    const { children, config } = props;
    const location = (0, router_1.useLocation)();
    const [intlLang, setIntlLang] = (0, react_1.useState)("fr_CA");
    (0, react_1.useEffect)(() => {
        if (location) {
            const pathname = location.pathname.length > 6 ? location.pathname.toString().substring(1, 6) : "";
            const pathnameUmbraco = location.pathname.length > 3 ? location.pathname.toString().substring(1, 4) : "";
            switch (pathname) {
                case "ca/fr":
                    setIntlLang("fr_CA");
                    break;
                case "ca/en":
                    setIntlLang("en_CA");
                    break;
                case "us/en":
                    setIntlLang("en_US");
                    break;
                default:
                    setIntlLang("fr_CA");
            }
            switch (pathnameUmbraco) {
                case "fr/":
                    setIntlLang("fr_CA");
                    break;
                case "en/":
                    setIntlLang("en_CA");
                    break;
            }
        }
    }, [location]);
    return (react_1.default.createElement(ServicesContextProvider_1.ServicesContextProvider, null,
        react_1.default.createElement(CookiesConsentContextProvider_1.CookiesConsentContextProvider, { config: (0, cookiesConsentProviderConfig_1.getFilteredConfig)(config), intlLang: intlLang },
            react_1.default.createElement(GoogleTagManager_1.default, { containerId: config.containerId }),
            children)));
};
exports.CookiesConsentProvider = CookiesConsentProvider;
//# sourceMappingURL=CookiesConsentProvider.js.map